// this is the page where admin can see all the payments made by customers, payments made to farmers and any other payments made by the admin
// this page will have a table with all the payments made
// this page will have a search bar to search for payments
// this page will have a filter to filter payments by date, amount, payment type, payment status
// this page will have a button to download the payments made
// each row is clickable and will take the admin to the payment details page

import CardTable from "components/Tables/CardTable";
import PaymentsTable from "components/Tables/PaymentsTable";
import React from "react";

// components

export default function Payments() {
    const data = [
        {
            id: 1,
            amount: 100,
            type: "Farmers Payment",
            status: "Paid",
            date: new Date(),
        },
        {
            id: 2,
            amount: 200,
            type: "Customer Payment",
            status: "Paid",
            date: new Date(),
        },
        {
            id: 3,
            amount: 300,
            type: "Admin Payment",
            status: "Paid",
            date: new Date(),
        },
    ];

    return (
        <>
            <div className="flex flex-wrap mt-4 bg-white ">
                <CardTable
                    color="light"
                    heading="Payments"
                    route="/admin/payments/create"
                    columns={[
                        { label: "Transaction ID", key: "transaction_id", render: (value) => <b>{value}</b> },
                        { label: "Payable Type", key: "payable_type" },
                        { label: "Payable", key: "payable" },
                        { label: "Amount(KES)", key: "amount", render: (value) => <span>{`${value.toFixed(2)}`}</span> },
                        { label: "Type", key: "type" },
                        { label: "Payment Method", key: "payment_method" },
                        { label: "Reference", key: "reference" },
                        { label: "Status", key: "status" },
                        { label: "Paid At", key: "paid_at", render: (value) => <span>{new Date(value).toLocaleString()}</span> },
                    ]}
                    data={[
                        {
                            transaction_id: "TXN12345",
                            payable_type: "Invoice",
                            payable: "John Doe",
                            amount: 150.00,
                            type: "Credit",
                            payment_method: "M-Pesa",
                            reference: "MP123456",
                            status: "Completed",
                            paid_at: "2024-11-28T14:30:00Z",
                        },
                        {
                            transaction_id: "TXN12346",
                            payable_type: "Invoice",
                            payable: "Jane Smith",
                            amount: 200.00,
                            type: "Debit",
                            payment_method: "Bank Transfer",
                            reference: "REF98765",
                            status: "Pending",
                            paid_at: "2024-11-29T08:45:00Z",
                        },
                        {
                            transaction_id: "TXN12347",
                            payable_type: "Purchase Order",
                            payable: "Mohamed Ali",
                            amount: 300.00,
                            type: "Credit",
                            payment_method: "Credit Card",
                            reference: "CC54321",
                            status: "Failed",
                            paid_at: "2024-11-27T11:00:00Z",
                        },
                        {
                            transaction_id: "TXN12348",
                            payable_type: "Invoice",
                            payable: "Emma Williams",
                            amount: 120.00,
                            type: "Debit",
                            payment_method: "Cash",
                            reference: "CASH65432",
                            status: "Completed",
                            paid_at: "2024-11-28T15:00:00Z",
                        },
                        {
                            transaction_id: "TXN12349",
                            payable_type: "Purchase Order",
                            payable: "Liam Johnson",
                            amount: 450.00,
                            type: "Credit",
                            payment_method: "PayPal",
                            reference: "PP123987",
                            status: "Completed",
                            paid_at: "2024-11-26T09:30:00Z",
                        },
                        {
                            transaction_id: "TXN12350",
                            payable_type: "Invoice",
                            payable: "Olivia Brown",
                            amount: 180.00,
                            type: "Debit",
                            payment_method: "M-Pesa",
                            reference: "MP112233",
                            status: "Completed",
                            paid_at: "2024-11-25T16:15:00Z",
                        },
                    ]}
                />

            </div>
        </>
    );
}
